export class Cache {
	static cache: { [key: string]: {
		value: string | false,
		expire: number,
	} | false } = {};

	static get(key: string): string | false {
		const cache = Cache.cache[key];
		if (!cache) {
			return false;
		}
		
		if( cache.expire < Date.now() ) {
			Cache.cache[key] = false;
			return false;
		}
		
		return cache.value;
	}

	static has(key: string): boolean {
		return Cache.get(key) !== false;
	}

	static set(key: string, value: string | false, seconds = 15) {
		Cache.cache[key] = {
			value,
			expire: Date.now() + seconds * 1000,
		};
	}

	static clear() {
		Cache.cache = {};
	}

	static clearKey(key: string) {
		Cache.cache[key] = false;
	}

}